import React from "react";
import "./webinarLandingPage.css";

const WebinarThankuHindi = () => {
  return (
    <div className="thankyou-container">
      <div className="thankyou-card">
        <h1 className="thankyou-title">🙏 धन्यवाद!</h1>
        <p className="thankyou-subtitle">
        मायोमानमो पितृपक्ष वेबिनार के लिए पंजीकरण करने के लिए धन्यवाद!

        </p>

        <div className="thankyou-details">
          <h2>📌 वेबिनार जानकारी
</h2>
          <ul>
            <li><strong> दिनांक :</strong>  7 सितंबर 2025
</li>
            <li><strong> सुबह :</strong>10 बजे से 11:30 बजे तक
</li>
            <li><strong>अवधि :</strong> १:३० तास</li>
            <li><strong>भाषा :</strong> मराठी</li>
            <li><strong>प्लेटफ़ॉर्म :</strong> ज़ूम</li>
            <li><strong>शुल्क :</strong> ₹५१</li>
          </ul>
        </div>

        <div className="thankyou-note">
          <p>✅ इस कार्यक्रम को अपने कैलेंडर में जोड़ें ताकि आप इसे मिस न करें।
</p>
          <p>
            📧 कार्यक्रम की तारीख के करीब आने पर आपको वेबिनार में शामिल होने के लिए ज़ूम मीटिंग लिंक के साथ एक अलग ईमेल प्राप्त होगा।

          </p>
        </div>
      </div>
    </div>
  );
};

export default WebinarThankuHindi;
